export const strings = {
  no_surveys: 'Anket mevcut değil',
  wait: 'Lütfen bekleyin....',
};
